import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.vehicles')
  .factory('vehiclesAPI', VehiclesAPI);

function VehiclesAPI(): BringozApi {
  return {
    base: `/vehicles`,
    infiniteScroll: {
      address: `/vehicles`,
      cmd: 'GET'
    },
    actions: {
      create: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      update: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      updateAgents: {
        address: 'agents/add',
        cmd: 'POST',
        updateable: true
      },
      remove: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      }
    }
  }
}
